import { FC, PropsWithChildren, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const TopBarActionsPortal: FC<PropsWithChildren> = ({ children }) => {
  const actionsContainer = document.getElementById('topbar-actions-container');
  const [hasContainerRendered, setHasContainerRendered] = useState(!!actionsContainer);

  // prevent rendering before the container
  useEffect(() => {
    const actionsContainer = document.getElementById('topbar-actions-container');
    setHasContainerRendered(!!actionsContainer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!hasContainerRendered || !actionsContainer) return null;
  return createPortal(children, actionsContainer);
};

export default TopBarActionsPortal;
